import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function HygieneCheckDialog({ open, mismatches, onCancel, onPublishAnyway, publishing }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="bg-[#121824] border-white/10 text-white" data-testid="hygiene-check-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-amber-400">
            <i className="fa-solid fa-magnifying-glass mr-2" />Your poster and page don't quite match
          </DialogTitle>
          <DialogDescription>
            Our AI scanned your event poster and found some differences from what's entered below.
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-1.5 max-h-56 overflow-y-auto">
          {mismatches.map((m, i) => (
            <li
              key={`${m.field}-${i}`}
              className="text-sm text-amber-300 bg-amber-500/10 rounded-lg px-3 py-2 space-y-0.5"
              data-testid={`hygiene-mismatch-item-${i}`}
            >
              <p className="font-semibold capitalize">{m.field}</p>
              <p className="opacity-80">Page says: <span className="font-mono-slug">{m.page_value || "(empty)"}</span></p>
              <p className="opacity-80">Poster says: <span className="font-mono-slug">{m.poster_value || "(not found)"}</span></p>
              {m.note && <p className="opacity-60 text-xs">{m.note}</p>}
            </li>
          ))}
        </ul>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onCancel} className="border-white/15 hover:bg-white/10" data-testid="hygiene-check-review-button">
            Review Page
          </Button>
          <Button onClick={onPublishAnyway} disabled={publishing} className="bg-amber-500 hover:bg-amber-600 text-black font-bold" data-testid="hygiene-check-publish-anyway-button">
            {publishing ? "Publishing..." : "Publish Anyway"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
